<template>
	<page>
		<module title="会员统计" enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="手机号">
				  <c-input name="user_manage_mobilephone"></c-input>
				</m-search-item>
				<m-search-item label="用户名">
					<c-input name="login_name"></c-input>
				</m-search-item>
				<m-search-item label="统计时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" type="date" range></c-datetime>
				</m-search-item>
			</m-search>
			
			<c-table ref="table">				

				<c-table-column
					label="手机号"
					name="user_manage_mobilephone"
					width="130"
				>
				</c-table-column>
				
				<c-table-column
					label="用户名"
					name="login_name"
					width="200"
				>
				</c-table-column>
				
				<c-table-column
					label="下单数量"
					name="order_quantity"
					width="100"
				>
				</c-table-column>
				
				<c-table-column
					label="下单总额"
					name="order_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.order_amount}}
					</template>
				</c-table-column>


				<c-table-column
					label="退款数量"
					name="refund_quantity"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="退款总额"
					name="refund_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.refund_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="售后数量"
					name="return_quantity"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="售后总额"
					name="return_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column>

			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_statistic_platform_user',
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/platform_user/list',
					data
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>